
  export default{
    name: 'NewsPage',
    data(){
      return{
        list:[],
      }
    },
    async asyncData(context) {
      /* let newsData=await context.$request.newsMgr.getHistory();

      let list=newsData.list.sort(function(a,b){
        if(a.date){
           return Date.parse(a.date.replace(/-/g,"/")) > Date.parse(b.date.replace(/-/g,"/")) ?-1:1;
        }
      });

      return {
        list:list,
      } */
    },
    mounted(){
       this.getNewsList();
    },
    methods:{
       getNewsList(){
          let localData=this.getSessionStorage("news");
          if(localData && localData.length>0){
            this.list=localData;
          }else{
             this.$request.newsMgr.getList().then((result)=>{
                if(result && result.list){
                   let newsList=result.list || [];
                   this.list=newsList;
                   this.setSessionStorage("news",newsList);
                }
             });
          }
       },
       getSessionStorage(key){
         return window.sessionStorage.getItem(key)? JSON.parse(window.sessionStorage.getItem(key)) :null;
       },
       setSessionStorage(key,data){
          window.sessionStorage.setItem(key,JSON.stringify(data));
       },
    }
  }
